import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_69566509-b9c0-48ae-b149-6b9accd67eee/artifacts/3nmi4pqp_Dynamic%20Logo%20with%20Sapphire%20Coral%20Gradient%20%288%29.png";

const Privacy = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-primary)' }}>
      {/* Header */}
      <header className="nav">
        <div className="nav-content">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="Shadesense.ai" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="btn-secondary flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container py-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-meta uppercase tracking-widest mb-4" style={{ color: 'var(--accent-primary)' }}>
            Legal
          </p>
          <h1 className="text-display mb-4" style={{ color: 'var(--text-primary)' }}>
            Privacy Policy
          </h1>
          <p className="text-body text-secondary mb-12">
            Effective Date: January 1, 2026
          </p>

          <div className="prose prose-lg" style={{ color: 'var(--text-secondary)' }}>
            <p className="text-body mb-8">
              This Privacy Policy explains how Shadesense Inc. collects, uses, and protects your information when you use Shadesense.ai.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>1. Information We Collect</h2>
            
            <h3 className="text-h3 mt-8 mb-3" style={{ color: 'var(--text-primary)' }}>Information You Provide</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li className="text-body">Name</li>
              <li className="text-body">Email address</li>
              <li className="text-body">Uploaded images</li>
              <li className="text-body">Saved palettes and wishlists (if applicable)</li>
            </ul>

            <h3 className="text-h3 mt-8 mb-3" style={{ color: 'var(--text-primary)' }}>Automatically Collected Information</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li className="text-body">IP address</li>
              <li className="text-body">Device and browser information</li>
              <li className="text-body">Usage analytics</li>
              <li className="text-body">Approximate location</li>
            </ul>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>2. How We Use Information</h2>
            <p className="text-body mb-4">We use your information to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li className="text-body">Provide and operate the Service</li>
              <li className="text-body">Process uploaded images and generate recommendations</li>
              <li className="text-body">Maintain accounts</li>
              <li className="text-body">Communicate service-related updates</li>
              <li className="text-body">Ensure security, performance, and reliability</li>
            </ul>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>3. Image Data & AI Processing</h2>
            <p className="text-body mb-4">Uploaded images are:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li className="text-body">Processed solely to provide the requested analysis</li>
              <li className="text-body">Stored temporarily</li>
              <li className="text-body">Processed exclusively by automated systems</li>
              <li className="text-body">Never reviewed by humans</li>
              <li className="text-body">Never used to train or improve AI models</li>
            </ul>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>4. Sharing of Information</h2>
            <p className="text-body mb-4">
              We do not sell personal data.
            </p>
            <p className="text-body mb-4">
              We may share limited information with trusted service providers (hosting, analytics, email delivery, error logging) solely to operate the Service.
            </p>
            <p className="text-body mb-6">
              We do not share personal data with advertisers, retailers, or affiliates.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>5. Affiliate Tracking</h2>
            <p className="text-body mb-6">
              When you voluntarily click on a product link, third-party retailers or affiliate networks may use cookies or similar technologies to attribute referrals for commission purposes. Shadesense does not control these third-party technologies.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>6. Cookies & Tracking</h2>
            <p className="text-body mb-6">
              We use essential, analytics, and preference cookies. See our <Link to="/cookies" className="underline" style={{ color: 'var(--accent-primary)' }}>Cookie Policy</Link> for details.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>7. Data Retention</h2>
            <p className="text-body mb-6">
              Personal data is retained only while your account remains active. You may delete your account and associated data at any time through your account settings.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>8. Your Rights</h2>
            <p className="text-body mb-6">
              You may access or delete your personal data directly through your account settings.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>9. Data Security</h2>
            <p className="text-body mb-6">
              We use reasonable administrative and technical safeguards to protect your information. No system can be guaranteed 100% secure.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>10. Changes</h2>
            <p className="text-body mb-6">
              We may update this Privacy Policy periodically. Updates will be posted with a revised effective date.
            </p>

            <h2 className="text-h2 mt-12 mb-4" style={{ color: 'var(--text-primary)' }}>11. Contact</h2>
            <p className="text-body mb-6">
              <a href="mailto:aisalesfunnel@gmail.com" className="underline" style={{ color: 'var(--accent-primary)' }}>aisalesfunnel@gmail.com</a>
            </p>
          </div>

          {/* Other Legal Links */}
          <div className="mt-16 pt-8" style={{ borderTop: '1px solid var(--border-subtle)' }}>
            <p className="text-small text-muted mb-4">Related Policies</p>
            <div className="flex flex-wrap gap-4">
              <Link to="/terms" className="text-small hover:underline" style={{ color: 'var(--accent-primary)' }}>Terms of Use</Link>
              <Link to="/cookies" className="text-small hover:underline" style={{ color: 'var(--accent-primary)' }}>Cookie Policy</Link>
              <Link to="/policies" className="text-small hover:underline" style={{ color: 'var(--accent-primary)' }}>All Policies</Link>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="text-meta text-muted">© 2026 Shadesense Inc. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
